import { get, httpDelete, patch } from 'store/http/httpAction';
import {
  SET_FILES,
  SYNC_AFTER_DELETE,
  REMOVE_SHARED_OBJECT
} from './actionTypes';

// utils
const getPrefixByType = type => {
  return `${type}/${type}_folder`;
};

const getDeletePrefixByType = type => {
  return `${type}`;
};

const setFiles = (type, files) => ({
  type: SET_FILES,
  payload: { type, files }
});

export const tryFetchFilesByFolderId = (id, type) => dispatch =>
  get(`/admin/${getPrefixByType(type)}/${id}`, {}, dispatch).then(data => {
    dispatch(setFiles(type, data.data));
  });

const syncAfterDelete = id => ({
  type: SYNC_AFTER_DELETE,
  payload: { id }
});

export const tryDeleteFile = (id, type) => dispatch =>
  httpDelete(`/admin/${getDeletePrefixByType(type)}/${id}`, {}, dispatch).then(
    data => {
      if (data.deleted) {
        dispatch(syncAfterDelete(id));
      }
    }
  );

export const removeSharedObject = (removedId, removedType) => ({
  type: REMOVE_SHARED_OBJECT,
  payload: { removedId, removedType }
});

export const tryPatchSharedValues = (
  folderId,
  type,
  sharedValues
) => dispatch =>
  patch(
    `/admin/${
      type === 'dashboard' ? 'dashboard_folder' : 'report_folder'
    }/${folderId}/share`,
    sharedValues,
    dispatch
  ).then(data => {});



// WEBPACK FOOTER //
// ./src/views/ReportListPanel/flow/actions.js